var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"70%","display":"block","margin":"auto","height":"250px!important"}},[_c('canvas',{ref:"chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }